/** Shared dialog size for every record-audit picker (branch, employee, participants, pair record). */
export const RECORD_AUDIT_PICKER_DIALOG_SIZE = 'xLarge' as const;
